import { render, staticRenderFns } from "./trans-handle.html?vue&type=template&id=607c4d6b&scoped=true&external"
import script from "./trans-handle.js?vue&type=script&lang=js&external"
export * from "./trans-handle.js?vue&type=script&lang=js&external"
import style0 from "./trans-handle.scss?vue&type=style&index=0&id=607c4d6b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c4d6b",
  null
  
)

export default component.exports